<template>
  <div v-if="categories.length">
    <ui-section
      v-for="section in sections"
      :key="section.id"
      :header="section.header"
      :resource="section.records"
      :layout="SectionLayout.ONE_LINE"
      progress
    ></ui-section>
  </div>

  <fragment v-else>
    <div class="o-page__no-results">
      {{ $t('search.noResults') }}
    </div>
    <ui-section
      :layout="SectionLayout.ONE_LINE"
      :resource="recommendations"
    ></ui-section>
  </fragment>
</template>
<script>
  import { SectionLayout } from '@/shared/enums';
  import { pageMixin } from '@/shared/mixins';
  import UiSection from '../section/index.vue';

  export default {
    components: {
      UiSection,
    },
    enums: {
      SectionLayout,
    },
    mixins: [
      pageMixin,
    ],
    props: {
      products: {
        type: Array,
        default: () => [],
      },
      recommends: Object,
    },
    data() {
      return {
        categories: [],
        sections: null,
        searchConfig: this.$services.resolve('search').data,
        subscriber: this.$services.resolve('subscriber'),
      };
    },
    computed: {
      recommendations() {
        return [];
      },
    },
    mounted() {
      this.load();
    },
    methods: {
      parse(records) {
        const searchCategories = this.subscriber.isKidsTheme ? this.searchConfig?.kids : this.searchConfig?.adult;
        this.sections = searchCategories.map((searchCategory) => {
          return {
            ...searchCategory,
            header: this.$t(`glossary.${searchCategory.name}`),
            records: records.filter((item) => {
              const itemCategories = [item.mainCategory, ...item.categories];
              const typeMatches = searchCategory.types?.includes(item.type);
              const labelMatches = !searchCategory.label || (itemCategories.some((category) => category.label === searchCategory.label));
              return labelMatches && typeMatches;
            }),
          };
        });

        this.categories = this.sections
          .filter((section) => section.records.length)
          .map((section) => ({
            label: section.label,
            name: section.header,
          }));
      },
      load() {
        this.categories = [];
        this.parse(this.products);
        this.pageSchema();
        this.pageLoaded();
      },
    },
  };
</script>
